export default {
  "[嘿嘿]": "https://www.emojiall.com/images/60/microsoft-teams/1f600.png",

  "[大笑]": "https://www.emojiall.com/images/60/microsoft-teams/1f604.png",

  "[嘻嘻]": "https://www.emojiall.com/images/60/microsoft-teams/1f601.png",

  "[斜眼笑]": "https://www.emojiall.com/images/60/microsoft-teams/1f606.png",

  "[苦笑]": "https://www.emojiall.com/images/60/microsoft-teams/1f605.png",
  
  "[眨眼]": "https://www.emojiall.com/images/60/microsoft-teams/1f609.png",

  "[羞涩微笑]": "https://www.emojiall.com/images/60/microsoft-teams/1f60a.png",

  "[喜笑颜开]": "https://www.emojiall.com/images/60/microsoft-teams/1f970.png",

  "[花痴]": "https://www.emojiall.com/images/60/microsoft-teams/1f60d.png",

  "[飞吻]": "https://www.emojiall.com/images/60/microsoft-teams/1f618.png",

  "[亲亲]": "https://www.emojiall.com/images/60/microsoft-teams/1f617.png",

  "[羞涩亲亲]": "https://www.emojiall.com/images/60/microsoft-teams/1f61a.png",

  "[含泪的笑脸]": "https://www.emojiall.com/images/60/microsoft-teams/1f972.png",
  
  "[好吃]": "https://www.emojiall.com/images/60/microsoft-teams/1f60b.png",

  "[吐舌]": "https://www.emojiall.com/images/60/microsoft-teams/1f61b.png",

  "[滑稽]": "https://www.emojiall.com/images/60/microsoft-teams/1f92a.png",

  "[眯眼吐舌]": "https://www.emojiall.com/images/60/microsoft-teams/1f61d.png",
  
  "[安静的脸]": "https://www.emojiall.com/images/60/microsoft-teams/1f92b.png",

  "[想一想]": "https://www.emojiall.com/images/60/microsoft-teams/1f914.png",

  "[闭嘴]": "https://www.emojiall.com/images/60/microsoft-teams/1f910.png",

  "[挑眉]": "https://www.emojiall.com/images/60/microsoft-teams/1f928.png",

  "[冷漠]": "https://www.emojiall.com/images/60/microsoft-teams/1f610.png",
  
  "[无语]": "https://www.emojiall.com/images/60/microsoft-teams/1f611.png",

  "[沉默]": "https://www.emojiall.com/images/60/microsoft-teams/1f636.png",

  "[得意]": "https://www.emojiall.com/images/60/microsoft-teams/1f60f.png",

  "[不高兴]": "https://www.emojiall.com/images/60/microsoft-teams/1f612.png",

  "[龇牙咧嘴]": "https://www.emojiall.com/images/60/microsoft-teams/1f62c.png",

  "[说谎]": "https://www.emojiall.com/images/60/microsoft-teams/1f925.png",

  "[松了口气]": "https://www.emojiall.com/images/60/microsoft-teams/1f60c.png",
  
  "[沉思]": "https://www.emojiall.com/images/60/microsoft-teams/1f614.png",

  "[困]": "https://www.emojiall.com/images/60/microsoft-teams/1f62a.png",

  "[流口水]": "https://www.emojiall.com/images/60/microsoft-teams/1f924.png",

  "[睡着了]": "https://www.emojiall.com/images/60/microsoft-teams/1f634.png",

  "[感冒]": "https://www.emojiall.com/images/60/microsoft-teams/1f637.png",

  "[发烧]": "https://www.emojiall.com/images/60/microsoft-teams/1f912.png",

  "[受伤]": "https://www.emojiall.com/images/60/microsoft-teams/1f915.png",

  "[恶心]": "https://www.emojiall.com/images/60/microsoft-teams/1f922.png",
  
  "[呕吐]": "https://www.emojiall.com/images/60/microsoft-teams/1f92e.png",

  "[打喷嚏]": "https://www.emojiall.com/images/60/microsoft-teams/1f927.png",

  "[脸发烧]": "https://www.emojiall.com/images/60/microsoft-teams/1f975.png",

  "[头晕眼花]": "https://www.emojiall.com/images/60/microsoft-teams/1f974.png",
};
